import { SelectItem } from '../components/forms/Select/Select.view';
import { enumValues } from './enumEnumerator';
import { TimezoneSetting } from '../models/graphql';
import { formatTimezoneToDisplay } from './timeFormatter';
import { set } from 'date-fns';

export const mapTimezone = (): SelectItem[] => {
  const timeZoneListItems: SelectItem[] = [];
  for (const value of enumValues(TimezoneSetting)) {
    // Set browser referenced timezone only if adding new workspace
    const timeZoneLabel = formatTimezoneToDisplay(value) || null;

    // Don't create ListItem if there is no label
    if (timeZoneLabel) {
      timeZoneListItems.push({
        label: timeZoneLabel,
        value: value
      });
    }
  }
  return timeZoneListItems;
};

export const localDateFromString = (date: string, timeZone: TimezoneSetting): Date => {
  const dateObject = new Date(date);
  const nowDateString = dateObject.toLocaleString('en-US', { timeZone });
  return new Date(nowDateString);
};

export const dateRoundTo = (date: Date, min = 15): Date => {
  const qtyMinutes = date.getMinutes() + 1;
  const modulo = qtyMinutes % min;

  const minutes = modulo === 0 ? qtyMinutes + 1 : qtyMinutes;

  const newMinutes = Math.ceil(minutes / min) * min;
  return set(date, { minutes: newMinutes, seconds: 0, milliseconds: 0 });
};
